import { FC, ReactElement } from 'react';

interface Props {
    condition: boolean | undefined;
    wrapper: FC<any>;
    children: NonNullable<ReactElement>;
}
const ConditionalWrapper = ({ condition, wrapper, children }: Props) => (condition ? wrapper(children) : children);
export default ConditionalWrapper;
